import React, { useEffect } from 'react';
import { HeroCarousel } from '@/components/home/HeroCarousel';
import { FeaturesSection } from '@/components/home/FeaturesSection';
import { ProductOverview } from '@/components/home/ProductOverview';
import { ProductLineup } from '@/components/home/ProductLineup';
// import { Gallery } from '@/components/home/Gallery';
import { VideoSection } from '@/components/home/VideoSection';
import { FAQ } from '@/components/home/FAQ';
import { ContactSection } from '@/components/home/ContactSection';

export const HomePage: React.FC = () => {
  useEffect(() => {
    // URLのハッシュに対応してスクロール
    console.log('[HomePage] Initial hash:', window.location.hash);
    if (window.location.hash) {
      let targetHash = window.location.hash;
      console.log('[HomePage] Original hash:', targetHash);

      // lineup-* の場合は #lineup にスクロール
      if (targetHash.startsWith('#lineup-')) {
        targetHash = '#lineup';
        console.log('[HomePage] Changed to:', targetHash);
      }

      const element = document.querySelector(targetHash);
      console.log('[HomePage] Target element:', element);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <>
      <HeroCarousel />
      <FeaturesSection />
      <ProductOverview />
      <ProductLineup />
      {/* <Gallery /> */}
      <VideoSection />
      <FAQ />
      <ContactSection />
    </>
  );
};
